import { toast } from 'react-toastify';
import { logoutAction } from '../redux/actions/authActions';
import { refreshTokenAction } from '../redux/actions/refreshTokenAction';
import { readProfile } from './authUtils';
import { AUTH_API } from './axios';

const setupAxiosInterceptors = (store) => {
  const { dispatch } = store;

  let refreshInFlight = null;

  const doRefresh = () => {
    if (!refreshInFlight) {
      refreshInFlight = dispatch(refreshTokenAction()).finally(() => {
        refreshInFlight = null;
      });
    }
    return refreshInFlight;
  };

  const requestInterceptor = (request) => {
    const accessToken = readProfile()?.accessToken;
    if (accessToken) {
      request.headers.Authorization = `Bearer ${accessToken}`;
    }
    return request;
  };

  const errorInterceptor = async (error) => {
    const status = error?.response?.status;

    if (status === 429) {
      toast.error('Забагато спроб. Спробуйте за хвилину.');
      return Promise.reject(error);
    }

    const prevRequest = error?.config;
    if (status === 401 && prevRequest && !prevRequest._retry) {
      prevRequest._retry = true;
      try {
        await doRefresh();
        const accessToken = readProfile()?.accessToken;
        if (!accessToken) throw new Error('refresh failed');
        prevRequest.headers['Authorization'] = `Bearer ${accessToken}`;
        return AUTH_API(prevRequest);
      } catch (_) {
        await dispatch(logoutAction());
        return;
      }
    }
    return Promise.reject(error);
  };

  AUTH_API.interceptors.request.use(requestInterceptor);
  AUTH_API.interceptors.response.use(null, errorInterceptor);
};

export default setupAxiosInterceptors;
